import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home_doisplanos';
import Quiz from './pages/Quiz_novo';
import Checkout from './pages/Checkout_final';
import Orders from './pages/view_orders';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/admin" element={<Orders />} />
      </Routes>
    </Router>
  );
}

export default App;
